import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CheckCircle2, XCircle, Loader2, ShieldCheck, Home } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const GeoWhitelist = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ loading: true, ok: false, message: '', userName: '' });

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setState({ loading: false, ok: false, message: 'Lien invalide (token manquant).' });
      return;
    }
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/geo/whitelist-via-token?token=${encodeURIComponent(token)}`, {
          method: 'POST',
        });
        const data = await res.json();
        if (res.ok && data.ok) {
          setState({ loading: false, ok: true, message: data.message, userName: data.user_name });
        } else {
          setState({
            loading: false,
            ok: false,
            message: (data.detail || 'Impossible de valider ce lien.'),
          });
        }
      } catch (e) {
        setState({ loading: false, ok: false, message: 'Erreur réseau. Merci de réessayer.' });
      }
    })();
  }, [params]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1F3A8A] to-[#2D4A9A] flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl overflow-hidden" data-testid="geo-whitelist-page">
        <div className="bg-gradient-to-r from-[#1F3A8A] to-[#2D4A9A] p-6 text-white flex items-center gap-3">
          <ShieldCheck className="h-10 w-10 flex-shrink-0" />
          <div>
            <h2 className="text-xl font-bold">Autorisation à l'étranger</h2>
            <p className="text-blue-100 text-sm">Whitelist géographique</p>
          </div>
        </div>
        <div className="p-6 text-center space-y-4">
          {state.loading ? (
            <>
              <Loader2 className="h-12 w-12 animate-spin text-[#1F3A8A] mx-auto" />
              <p className="text-slate-600">Validation du lien…</p>
            </>
          ) : state.ok ? (
            <>
              <CheckCircle2 className="h-16 w-16 text-emerald-500 mx-auto" />
              <p className="font-semibold text-slate-800 text-lg">Fait !</p>
              <p className="text-slate-600 text-sm">{state.message}</p>
              {state.userName && (
                <p className="text-xs text-slate-500">
                  Utilisateur autorisé : <strong>{state.userName}</strong>
                </p>
              )}
            </>
          ) : (
            <>
              <XCircle className="h-16 w-16 text-red-500 mx-auto" />
              <p className="font-semibold text-slate-800 text-lg">Impossible d'autoriser</p>
              <p className="text-slate-600 text-sm">{state.message}</p>
            </>
          )}
          <Button
            onClick={() => navigate('/admin/users')}
            className="w-full bg-[#1F3A8A] hover:bg-[#162d6d]"
            data-testid="geo-whitelist-back-btn"
          >
            <Home className="h-4 w-4 mr-2" />
            Retour à la gestion des utilisateurs
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GeoWhitelist;
